import DatabaseModel from './DatabaseModel.js';

var ListaPrecio = Object.create(DatabaseModel);

ListaPrecio.model = 'listaprecio';
ListaPrecio.modelFront = 'listasprecios';

export default ListaPrecio;